

import { Component, Prop, Mixins } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component
export default class ThemedIcon extends Mixins(DarkThemeInfoMixin) {
    @Prop({ default: false }) readonly left!: boolean;
    @Prop({ default: false }) readonly small!: boolean;
    @Prop({ default: '' }) readonly color!: string;
    // v-on prop is used by elements that need activation like a tooltip when
    // hovering on the button, or a dialog that opens on click
    @Prop() readonly vOn!: object;
}
